import { fetchAuthSession } from "aws-amplify/auth";
import { post } from "aws-amplify/api";
import { useMutation, useQueryClient } from "react-query";
import { MINOR_DEPENDENTS_QUERY_KEY } from "./useMinorDependentsQuery";

export const useMinorDependentPostMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formInputs) => {
      const session = await fetchAuthSession();
      const { body } = await post({
        apiName: "careprovidersapi",
        path: "/minor-dependents",
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: formInputs,
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [MINOR_DEPENDENTS_QUERY_KEY] });
    },
  });
};
